/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Metric_RepsInputs */

const en_us2_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps`)
};

const pt_br2_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições`)
};

const es_419_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reps`)
};

const pt_pt2_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetições`)
};

const fr_fr2_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rép.`)
};

const de_de2_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdh.`)
};

const it_it2_exercise_sheet_metric_reps = /** @type {(inputs: Exercise_Sheet_Metric_RepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ripetizioni`)
};

/**
* | output |
* | --- |
* | "Reps" |
*
* @param {Exercise_Sheet_Metric_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_metric_reps = /** @type {((inputs?: Exercise_Sheet_Metric_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Metric_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_metric_reps(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_metric_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_metric_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_metric_reps(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_metric_reps(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_metric_reps(inputs)
	return en_us2_exercise_sheet_metric_reps(inputs)
});
export { exercise_sheet_metric_reps as "exercise-sheet.metric_reps" }